<template>
  <LoadingOverlay v-if="isLoading" :active="true" :can-cancel="false" />
  <router-view></router-view>
</template>

<script>
import { useLoadingStore } from "@/stores/loadingStore";
import { useIsEditStore } from "@/stores/isEditStore";
import { mapState, mapStores } from "pinia";
import LoadingOverlay from "vue3-loading-overlay";

const CHUNK_FAILURE_EVENT = "app:chunk-load-failed";
const CHUNK_RECOVERED_EVENT = "app:chunk-load-recovered";
const CHUNK_RELOAD_KEY = "__chunk_reload_state__";

export default {
  name: "App",
  components: { LoadingOverlay },
  data() {
    return {
      chunkLoadFailed: false,
      chunkLoadMessage: "系統版本已更新，請重新載入頁面後再繼續操作。",
    };
  },
  computed: {
    // 讓 isLoading 直接綁定到 Pinia 的狀態
    ...mapState(useLoadingStore, ["isLoading"]),
    ...mapStores(useIsEditStore),
  },
  watch: {
    // isLoading(val) {
    //   const s = useLoadingStore();
    //   console.log("[App isLoading]", val, "activeRequests:", s.activeRequests);
    // },
  },
  methods: {
    handleBeforeUnload(e) {
      if (this.isEditStore.isEdit) {
        e.preventDefault();
        e.returnValue = "";
      }
    },
    handleChunkLoadFailed(event) {
      this.chunkLoadFailed = true;
      const resource = event?.detail?.resource || "";
      this.chunkLoadMessage = resource
        ? "系統已更新，請重新整理頁面後再繼續操作。"
        : "系統已更新，請重新整理頁面後再繼續操作。";
      const loadingStore = useLoadingStore();
      loadingStore.reset();
    },
    handleChunkLoadRecovered() {
      this.chunkLoadFailed = false;
      this.chunkLoadMessage = "系統已更新，請重新整理頁面後再繼續操作。";
    },
    reloadPage() {
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      try {
        const url = new URL(location.href);
        url.searchParams.set("_v", Date.now().toString());
        location.replace(url.toString());
      } catch (error) {
        location.reload();
      }
    },
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    window.addEventListener(CHUNK_FAILURE_EVENT, this.handleChunkLoadFailed);
    window.addEventListener(
      CHUNK_RECOVERED_EVENT,
      this.handleChunkLoadRecovered
    );
    // const s = useLoadingStore();
    // console.log("app store", s.$id, s.activeRequests);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    window.removeEventListener(CHUNK_FAILURE_EVENT, this.handleChunkLoadFailed);
    window.removeEventListener(
      CHUNK_RECOVERED_EVENT,
      this.handleChunkLoadRecovered
    );
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+TC&display=swap");
@import "./assets/all.scss";
#app {
  font-family: "Noto Sans", sans-serif;
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  display: flex;
  min-height: 100vh;
  background-color: #f5f6f8;
}

.chunk-fallback {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding: 24px;
  background-color: #f5f6f8;
}

.chunk-fallback__card {
  width: 100%;
  max-width: 420px;
  padding: 32px 28px;
  border-radius: 16px;
  background-color: white;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.chunk-fallback__title {
  color: #1f2d3d;
  font-size: 24px;
  font-weight: 700;
}

.chunk-fallback__text {
  margin-top: 12px;
  color: #5c6b77;
  line-height: 1.6;
}

.chunk-fallback__button {
  cursor: pointer;
  width: 100%;
  height: 44px;
  margin-top: 24px;
  border: none;
  border-radius: 10px;
  color: white;
  background-color: #4695c9;
  font-size: 16px;
  transition: filter 0.2s;

  &:hover {
    filter: brightness(1.05);
  }
}
</style>
